import React, { useState, useEffect, useCallback } from 'react';
import Sidebar from './components/Sidebar';
import MainFeed from './components/MainFeed';
import RankBoard from './components/RankBoard';
import DanmakuPage from './pages/DanmakuPage';
import LoginModal from './components/LoginModal';
import { AuthProvider, useAuth } from './hooks/useAuth';
import { postApi, tagApi } from './api';
import './App.css';

function AppContent() {
  const { user } = useAuth();
  const [currentView, setCurrentView] = useState('home');
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showLogin, setShowLogin] = useState(false);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);

  // 加载帖子列表
  const loadPosts = useCallback(async (pageNum = 1, append = false) => {
    try {
      setLoading(true);
      const result = await postApi.getList(pageNum, 10);
      const newPosts = result.records || [];
      setPosts(prev => append ? [...prev, ...newPosts] : newPosts);
      setHasMore(newPosts.length === 10);
      setPage(pageNum);
    } catch (error) {
      console.error('加载帖子失败:', error);
    } finally {
      setLoading(false);
    }
  }, []);

  // 加载热门标签
  const loadHotTags = useCallback(async () => {
    // 移除了热门标签加载，因为首页不再需要
  }, []);

  useEffect(() => {
    loadPosts();
    // 移除了loadHotTags调用
  }, [loadPosts]);

  // 发布帖子
  const addPost = async (newPost) => {
    if (!user) {
      setShowLogin(true);
      return;
    }
    try {
      const post = await postApi.create(newPost);
      setPosts(prev => [post, ...prev]);
    } catch (error) {
      console.error('发布失败:', error);
      alert(error.message);
    }
  };

  // 更新反应
  const updateReaction = async (postId, reactionType) => {
    if (!user) {
      setShowLogin(true);
      return;
    }
    try {
      await postApi.addReaction(postId, reactionType);
      setPosts(prev => prev.map(post =>
        post.id === postId
          ? { ...post, reactions: { ...post.reactions, [reactionType]: post.reactions[reactionType] + 1 } }
          : post
      ));
    } catch (error) {
      console.error('操作失败:', error);
    }
  };

  // 加载更多
  const loadMore = () => {
    if (!loading && hasMore) {
      loadPosts(page + 1, true);
    }
  };

  return (
    <div className="min-h-screen bg-slate-950 text-slate-200">
      {currentView === 'danmaku' ? (
        <DanmakuPage onBack={() => setCurrentView('home')} />
      ) : (
        <div className="flex">
          <Sidebar
            currentView={currentView}
            setCurrentView={setCurrentView}
            onLoginClick={() => setShowLogin(true)}
          />

          <main className="flex-1 ml-64">
            <div className="flex w-full">
              <div className="flex-1 min-w-0">
                <MainFeed
                  posts={posts}
                  addPost={addPost}
                  updateReaction={updateReaction}
                  currentView={currentView}
                  loading={loading}
                  hasMore={hasMore}
                  onLoadMore={loadMore}
                />
              </div>

              <div className="w-80 flex-shrink-0 p-6">
                <RankBoard posts={posts} />
              </div>
            </div>
          </main>
        </div>
      )}

      {currentView !== 'danmaku' && (
        <footer className="bg-slate-900 border-t border-slate-800 py-8 text-center">
          <p className="text-slate-400 italic">
            在这里，你不是谁的下属，你是你自己的英雄。
          </p>
          <p className="text-xs text-slate-500 mt-2">
            本站不记录IP，不要求实名，请放心吐槽 | 恶心爆了 © 2026
          </p>
        </footer>
      )}

      {showLogin && <LoginModal onClose={() => setShowLogin(false)} />}
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;
